/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_7567
 */

import { message } from 'ant-design-vue'
import {
  buyitwith_list_post,
  buyitwith_modify_post,
  buyitwith_page_post,
  buyitwith_query_id_get,
  buyitwith_save_post
} from 'server/modules/7567'

// 查询重复配置
export const buyitwith_list_post_ = async function(params) {
  const { success, data, retInfo } = await buyitwith_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 编辑
export const buyitwith_modify_post_ = async function(params) {
  const { success, data, retInfo } = await buyitwith_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分页查询
export const buyitwith_page_post_ = async function(params, state) {
  const { success, data, retInfo } = await buyitwith_page_post(params)
  if (success) {
    const { pageNum, pageSize, total, list } = data
    state.pagination = {
      pageNum,
      pageSize,
      total
    }
    state.dataSource = list
  } else {
    message.error(retInfo)
  }
}

// 查询单个条目
export const buyitwith_query_id_get_ = async function(params) {
  const { success, data, retInfo } = await buyitwith_query_id_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 保存
export const buyitwith_save_post_ = async function(params, state) {
  const { success, data, retInfo } = await buyitwith_save_post(params)
  if (success) {
    const { pageNum, pageSize, total, list } = data
    state.pagination = {
      pageNum,
      pageSize,
      total
    }
    state.dataSource = list
  } else {
    message.error(retInfo)
  }
}
